module.exports = __webpack_public_path__ + "public/img/qrcode-wechat.e149e8dd.png";